import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Plus } from 'lucide-react';

export default function AdminCourses() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title:'', description:'', cover_url:'' });
  const load = () => api.get('/courses').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.post('/courses', f); toast.success('Curso creado'); setOpen(false); load(); }
    catch { toast.error('Error'); }
  };
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Cursos" subtitle="Administra el contenido educativo"
        right={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button className="rounded-full bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1"/>Nuevo curso</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Crear curso</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <Input placeholder="Título" value={f.title} onChange={(e)=>setF({...f,title:e.target.value})}/>
                <Textarea placeholder="Descripción" value={f.description} onChange={(e)=>setF({...f,description:e.target.value})}/>
                <Input placeholder="URL de portada" value={f.cover_url} onChange={(e)=>setF({...f,cover_url:e.target.value})}/>
              </div>
              <DialogFooter><Button onClick={save}>Crear</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(c => (
          <div key={c.id} className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
            <div className="h-32 bg-slate-100" style={{backgroundImage:`url(${c.cover_url})`, backgroundSize:'cover', backgroundPosition:'center'}}/>
            <div className="p-4">
              <div className="font-display font-bold">{c.title}</div>
              <div className="text-sm text-slate-500 line-clamp-2">{c.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
